<template>

<div class="col-md-6 border-0">
    <div class="ibox dasboard_graph">
        <div class="ibox-title dashboard_title company-form-box-title pf-contribution">
            <div class="clearfix">
                <div class="left_container">
                    <ul class="title_list">
                        <li class="title-text">Joiners and Leavers</li>
                        <li class="devider_list"><span class="devider"></span></li>
                        <li class="legend_list joinners_graph"><span class="text">Joiners</span></li>
                        <li class="legend_list leavers_graph"><span class="text">Leavers</span></li>
                    </ul>
                </div>
                <div class="right_container">
                    <template v-if="payrunsfiscalyear.length > 0">
                        <b-form-select class="dasboard_graph_select" v-model="search_join.fiscal_year"  @change="setSearchJoin()">
                            <option value="null">Select Fiscal Year</option>
                            <option v-for='fyear in payrunsfiscalyear' :value='fyear.fiscal_year'  >{{fyear.fiscal_year }}</option>
                        </b-form-select>
                    </template>
                </div>

            </div>
        </div>
        <div class="ibox-content">
            <template v-if="lineJoiningDatas != null">
                <line-chart :chart-data="lineJoiningDatas" :options= "joining_options_line" :styles="myStyles"  class="pb-3"></line-chart>
            </template>
        </div>
    </div>
</div>

</template>

<script>
    import moment from 'moment';
    export default{

        mounted() {

        },
        props: ['payrunsfiscalyear'],
        components: {

        },
        data(){

            return {
                search_join:{ fiscal_year:null},
                joining_options_line:[],
                joining_data:[],
                lineJoiningDatas:null,

            }
        },
        methods:{

            setSearchJoin: function(pageflg)
            {
                this.get_joiner_leaver_data();
            },
            lineJoiningData: function(fixed,variable,month,step_size)
            {
                this.lineJoiningDatas={

                    labels: month,
                    datasets: [
                        {
                            label: 'Joiners',
                            data: fixed,

                            borderColor: '#8F9ADE',
                            borderWidth: 5
                        },
                        {
                            label: 'Leavers',
                            data:variable,

                            borderColor: '#CC5057',
                            borderWidth: 5
                        },

                    ]

                };

                this.joining_options_line= {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: false
                    },
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero: true,
                                steps: 15,
                                stepSize: 3,

                                }

                        }]
                    }
                };

                this.myStyles={


                };

            },
            get_joiner_leaver_data: function()
            {


            axios.get(this.$api_url+'/pyaroll-test' , {
                    params: {

                        search_query: this.search_join,

                    }
            }).then(function(response){
                //this.search_join.fiscal_year = '';

                this.joining_data = response.data;

                let joining = [];
                let joining_final = [];
                let leaving = [];
                let leaving_final = [];
                let month = [];
                let step = 0;

                joining = this.joining_data.join_employee;

                leaving = this.joining_data.leave_employee;
                let ct = 0;

                Object.keys(joining).forEach(function(key) {


                    if(joining[key]>step)
                    {
                        step = joining[key];
                    }
                    month.push(key);
                    joining_final.push(joining[key]);

                    ct++;
                });

                ct = 0;
                Object.keys(leaving).forEach(function(key) {

                    leaving_final.push(leaving[key]);

                    ct++;
                });



                if(ct == 12 && step>0)
                {
                    step = step * 2;
                    step = step/10;

                    this.lineJoiningData(joining_final,leaving_final,month,step);
                }




                }.bind(this));
            },

        },
        created: function()
        {
            if(this.payrunsfiscalyear.length > 0)
            {
                this.search_join.fiscal_year=this.payrunsfiscalyear[0].fiscal_year;
                // Abdullah after live added this
                this.get_joiner_leaver_data();
            }
        }
    }
</script>
